<template>  
    <v-expansion-panels accordion v-model="expanded">
        <v-expansion-panel v-if="canAdd">
            <v-expansion-panel-header>Add Files</v-expansion-panel-header>
            <v-expansion-panel-content>
                <AddOtherFiles :monthlyPoolID="monthlyPoolID" @created="FilesCreated"></AddOtherFiles>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
            <v-expansion-panel-header>Existing Files</v-expansion-panel-header>
            <v-expansion-panel-content>
                <HistoricalFiles
                    ref="historicalFiles"
                    :monthlyPoolID="monthlyPoolID"></HistoricalFiles>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
    
</template>

<script>
import AddOtherFiles from "./AddOtherFiles";
import HistoricalFiles from "./HistoricalFiles"

export default {
    components: {
        AddOtherFiles,
        HistoricalFiles
    },
    props: {
        canAdd: {
            type: Boolean,
            default: true
        },
        monthlyPoolID: {
            type: Number,
            default: -1
        },
      
    },
    data() {
        return {
            expanded: 0
        };
    },
    methods: {
        FilesCreated() {
            if(this.$refs.historicalFiles!==null && this.$refs.historicalFiles !== undefined){
                this.$refs.historicalFiles.loadFiles();
            }
            
        }
    },
    async created() {
    }
}
</script>